export default __webpack_public_path__ + "fonts/poppins-latin-700-normal.d86662fe776dae29ea78.woff2";